import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import "../assets/css/general.css"; // récupère vos styles globaux (incluant .settings-sidebar)

export default function SettingCenter({ isOpen, onClose }) {
  return (
    <div className={`settings-sidebar ${isOpen ? "" : "hidden"}`}>
      <div className="settings-header">
        <h2>Menu &amp; paramétrage</h2>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>

      <nav className="settings-nav secondary">
        <Link to="/edit-profile" className="settings-item" onClick={onClose}>
          <i className="fa-regular fa-user" />
          <span>Modifier mon profil</span>
        </Link>
        <Link
          to="/interim/listAgency"
          className="settings-item"
          onClick={onClose}
        >
          <i className="fa-solid fa-building" />
          <span>Agences d’intérims</span>
        </Link>
        <Link to="/job-offer" className="settings-item" onClick={onClose}>
          <i className="fa-solid fa-briefcase" />
          <span>Toutes les offres d’emplois</span>
        </Link>
        <div className="divider" />
      </nav>

      <div className="settings-footer">
        <button
          className="support-btn"
          onClick={() => (window.location.href = "/support")}
        >
          Contact support
        </button>
      </div>
    </div>
  );
}
